<template>
    <div class="modal-backdrop" role="dialog" id="AppSettingsComponent">
        <div class="modal" ref="modal">
            <header class="modal-header">
                <slot name="header">
                    <h2>
                        {{$t('components.app-settings.title')}}
                    </h2>

                    <button type="button" class="btn-close" @click="close">
                        <i class="fas fa-times"></i>
                    </button>
                </slot>
            </header>

            <section class="modal-body">
                <slot name="body">
                    <div class="row">
                        <div class="col-sm-10">
                            <div class="settings-item">
                                {{$t('components.app-settings.options.api.hasPrice.title')}}
                                <b-button class="btn-none" id="tooltip-apps-pricedisplay">
                                    <i class="fas fa-info-circle"></i>
                                </b-button>
                                <b-tooltip target="tooltip-apps-pricedisplay" triggers="hover">
                                    {{$t('components.app-settings.options.api.hasPrice.desc')}}
                                </b-tooltip>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <label class="switch">
                                <input type="checkbox" :checked="priceDisplay" @change="setPriceDisplay">
                                <span class="slider round"></span>
                            </label>
                        </div>
                    </div>
                </slot>
            </section>
        </div>
    </div>
</template>

<script>
    import AccountApiService from "../../api/account.api";

    export default {
        name: "AppSettings",
        methods: {
            close() {
                this.$emit('close');
            },

            setPriceDisplay(event) {
                let value = event.target.checked;
                this.$swal.fire({
                    icon: "question",
                    title: this.$t('confirm.title'),
                    html: this.$t('components.app-settings.options.api.hasPrice.warning'),
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonColor: '#b89453',
                    cancelButtonColor: '#ccc',
                    confirmButtonText: this.$t('confirm.yes'),
                    cancelButtonText: this.$t('confirm.no'),
                }).then((result) => {
                    if (result.value) {
                        let loader = this.$loading.show();
                        AccountApiService.settings.setOption('API->hasPrice', value)
                            .then(() => location.reload(true))
                            .catch(() => {
                                this.$swal.fire({
                                    icon: "error",
                                    allowOutsideClick: false,
                                    html: this.$t('whoops')
                                });
                                loader.hide();
                                loader = null;
                                event.target.checked = !value;
                            })
                    } else {
                        event.target.checked = !value;
                    }
                });
            }
        },
        computed: {
            priceDisplay() {
                return this.$store.getters["authStore/appSettings"].api.hasPrice;
            }
        }
    }
</script>

<style scoped>

    .modal-backdrop {
        position: fixed;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 1 !important;
    }

    .modal {
        width: calc(30%);
        background: #ffffff;
        box-shadow: 2px 2px 20px 1px;
        display: flex;
        flex-direction: column;
        right: 0;
        left: unset;
    }

    .modal-header {
        padding: 15px;
        display: flex;
    }

    .modal-header {
        border-bottom: 1px solid #eeeeee;
        color: #b89453;
        justify-content: space-between;
    }

    .modal-body {
        position: relative;
        padding: 20px 10px;
    }

    .btn-close {
        border: none;
        font-size: 20px;
        padding: 20px;
        cursor: pointer;
        font-weight: bold;
        color: #b89453;
        background: transparent;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #b89453;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #b89453;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    .settings-item {
        font-size: 23px;
    }
</style>
